/* eslint-disable arrow-body-style */

import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import ReportDatePicker, { IReportDateValue } from '../ReportDatePicker';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportFilter } from '@gp/types/dpsReport/common';

interface IAddReportFilterProps extends IBaseProps {
  disabledWeeks?: string[][];
  value: IDPSReportFilter;
  onChange?: (payload: IDPSReportFilter) => void;
}

const AddReportFilter: React.FC<IAddReportFilterProps> = (props) => {
  const { style, className, disabledWeeks, value, onChange } = props;

  const date = useMemo<IReportDateValue>(() => {
    const { start_date: startDate, end_date: endDate } = value || {};
    return { start_date: startDate || '', end_date: endDate || '' };
  }, [value]);

  const handleDateChange = useMemoizedFn((payload: IReportDateValue) => {
    const { start_date: startDate, end_date: endDate } = payload || {};
    const valueTmp = {
      ...value,
      start_date: startDate || '',
      end_date: endDate || '',
    };
    onChange?.(valueTmp);
  });

  return (
    <div style={style} className={classnames('dbg-dps-report__filter', className)}>
      <ReportDatePicker disabledWeeks={disabledWeeks} value={date} onChange={handleDateChange} />
    </div>
  );
};

export default AddReportFilter;
